import { FC, useContext } from 'react';
import { BuildInAppToolId, IAppToolProps, IAppToolsContext } from '../../../types/appTools';
import AppToolsContext from '../../../context/AppToolsContext';
import MeetingsTool from '../../../../meetings/schedule/MeetingsTool';
import AppTool from './AppTool';
import { BoundModalProvider } from '@bizzabo/design-system';
import MeetingsToolEnabled from '../../../toolsEnabled/MeetingsToolEnabled';

const MeetingsAppTool: FC<IAppToolProps> = ({ selectedApp }) => {
    const { eventUniqueName } = useContext<IAppToolsContext>(AppToolsContext);

    return (
        <MeetingsToolEnabled>
            {({ isLoading, isEnabled }) => (
                <AppTool
                    selectedApp={selectedApp}
                    appTool={BuildInAppToolId.Meetings}
                    isEnabled={isEnabled}
                    isLoading={isLoading}
                >
                    <BoundModalProvider>
                        <MeetingsTool eventUniqueName={eventUniqueName} />
                    </BoundModalProvider>
                </AppTool>
            )}
        </MeetingsToolEnabled>
    );
};

export default MeetingsAppTool;
